import PropTypes from "prop-types";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation"; /* eslint-disable-line import/no-unresolved */
import { Line } from "react-chartjs-2";

import "./line.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

const LineChart = ({ id, data, options, plugins, ariaLabel, height }) => {
  return (
    <div id={id} className="line-chart" style={{ height: height }}>
      <Line
        options={options}
        data={data}
        plugins={plugins}
        aria-label={ariaLabel}
      />
    </div>
  );
};

LineChart.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  plugins: PropTypes.array,
  ariaLabel: PropTypes.string,
  height: PropTypes.string,
};

LineChart.defaultProps = {
  id: "lineChart",
  height: "372px",
};

export default LineChart;
